import { render, staticRenderFns } from "./AccountBanksModule.vue?vue&type=template&id=10244da8"
import script from "./AccountBanksModule.vue?vue&type=script&lang=js"
export * from "./AccountBanksModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports